'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { apiClient } from '@/lib/api/client';

export function ApiLocaleSync() {
  const locale = useLocale();

  useEffect(() => {
    apiClient.setLocale(locale);
  }, [locale]);

  return null;
}
